import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticClass: "supplier-container"
  }, [_c("SupplierSelectComponent", {
    key: "supplierSelect-" + _vm.boolRender,
    ref: "supplierSelect",
    attrs: {
      suppliers: _vm.suppliers,
      selected: _vm.formAdd.supplierId,
      required: true,
      disabled: _vm.isLoading
    },
    on: {
      changeSupplier: _vm.changeSupplier,
      fetchSuppliers: _vm.fetchSuppliersWhenItemsUpdated
    }
  }), _c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "Price / btl (€)",
      placeholder: "0.00",
      type: "number",
      min: "0.00",
      required: "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.formAdd.price,
      callback: function callback($$v) {
        _vm.$set(_vm.formAdd, "price", $$v);
      },
      expression: "formAdd.price"
    }
  })], 1), _c("div", [_c(VTextarea, {
    staticClass: "full",
    attrs: {
      label: "Comment",
      "hide-details": "auto"
    },
    model: {
      value: _vm.formAdd.comment,
      callback: function callback($$v) {
        _vm.$set(_vm.formAdd, "comment", $$v);
      },
      expression: "formAdd.comment"
    }
  })], 1), _c("div", {
    staticClass: "action-add"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: "",
      disabled: _vm.isInvalidForm,
      loading: _vm.isAdding
    },
    on: {
      click: function click($event) {
        return _vm.addSupplierPrice();
      }
    }
  }, [_vm._v(" Add ")])], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };